export default __webpack_public_path__ + "static/Michael hill-a5d1c642e47c043170fcd324ac67bc3d.svg";